function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isPastDate } from './isPastDate';
import { hasSpacesAtBeginning, hasSpacesAtEnd } from './validateSpaces';
export const validationRuleMessageBuilder = () => {
  const rules = {};
  const withRequired = required => {
    rules.required = {
      value: required,
      message: 'This field is required.'
    };
    return builder;
  };
  const withMaxLength = maxLength => {
    rules.maxLength = {
      value: maxLength,
      message: "Should NOT be longer than ".concat(maxLength.toString(), " characters.")
    };
    return builder;
  };
  const withMinLength = minLength => {
    rules.minLength = {
      value: minLength,
      message: "Should NOT be shorter than ".concat(minLength.toString(), " characters.")
    };
    return builder;
  };
  const withMin = min => {
    rules.min = {
      value: min,
      message: "Should NOT be less than ".concat(min.toString(), ".")
    };
    return builder;
  };
  const withCustomValidation = customValidation => {
    rules.validate = _objectSpread(_objectSpread({}, rules.validate), customValidation);
    return builder;
  };
  const withSpacesAtBeginningValidation = () => {
    rules.validate = _objectSpread(_objectSpread({}, rules.validate), {}, {
      validateSpacesAtBeginning: rating => !hasSpacesAtBeginning(rating) || 'Should NOT have space signs at the beginning.'
    });
    return builder;
  };
  const withIntegerValidation = () => {
    const integerRegExp = /^\d{1,}$/;
    rules.validate = _objectSpread(_objectSpread({}, rules.validate), {}, {
      validateIsInteger: value => integerRegExp.test(value) || 'Should be an integer.'
    });
    return builder;
  };
  const withSpacesAtEndValidation = () => {
    rules.validate = _objectSpread(_objectSpread({}, rules.validate), {}, {
      validateSpacesAtEnd: rating => !hasSpacesAtEnd(rating) || 'Should NOT have space signs at the end.'
    });
    return builder;
  };
  const withNoPastDate = () => {
    rules.validate = _objectSpread(_objectSpread({}, rules.validate), {}, {
      noPastDate: date => !isPastDate(date) || 'Should NOT be in the past.'
    });
    return builder;
  };
  const build = () => rules;
  const builder = {
    withRequired,
    withMaxLength,
    withMinLength,
    withMin,
    withCustomValidation,
    withSpacesAtBeginningValidation,
    withSpacesAtEndValidation,
    withIntegerValidation,
    withNoPastDate,
    build
  };
  return builder;
};